import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidateDocumentRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/ValidateDocumentRequest';
import * as DocumentsUtils from '../documents/utils/validator-generator';
import { description_min_rows, MAX_LENGTH_VALIDATOR_KEY, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';

@Component({
  selector: 'pt-create-snapshot-dialog',
  template: `
    <div class='modal-header modal-header__with-description'>
      <h4 class='modal-title'>
        {{"TITLE.CREATE_SNAPSHOT" | translate}}
      </h4>
      <p class="mb-0">Questa funzionalità storicizza un PDF contenente tutti i <code>tab</code> in stato <code>Approvato</code> o <code>In lavorazione</code></p>
    </div>
    <div class='modal-body' style="max-height: 300px; overflow-y: auto">

      <form *ngIf='formGroup' [formGroup]='formGroup'>
        <pt-input-text
          [controlName]='"name"'
          formControlName='name'
          [label]="'LABELS.NAME' | translate"
          [validators]='[REQUIRED, MAX_LENGTH]'
        ></pt-input-text>

        <pt-input-text-area
          [minRow]="5"
          [maxLength]="450"
          [inputId]='"description"'
          formControlName='description'
          [label]="'LABELS.DESCRIPTION' | translate"
        ></pt-input-text-area>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid'
              (click)='confirm()'>
        {{ 'BUTTON.CREATE' | translate }}
      </button>
      <button type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false)'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `,
  styles: [`
    .modal-header__with-description {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .modal-header__with-description p {
      margin-bottom: 0;
    }
  `]
})
export class CreateSnapshotDialogComponent {
  public REQUIRED = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
  public MAX_LENGTH = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(MAX_LENGTH_VALIDATOR_KEY,[128]);

  public formGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    description: new FormControl(null, [Validators.maxLength(450)]),
  })
  constructor(
    public activeModal: NgbActiveModal,
    private store: Store,
  ) {
  }

  run(name: string): void {
    this.formGroup.setValue({
      name: name,
      description: null
    })
  }

  confirm() {
    const request: ValidateDocumentRequest = {
      name: this.formGroup.controls.name.value,
      description: this.formGroup.controls.description.value
    };
    this.activeModal.close(request);
  }

  protected readonly descriptionMinRows = description_min_rows;
}
